export default __webpack_public_path__ + "static/media/video.fe701c20.mp4";